import React from 'react';
import { Text, View, StyleSheet,Font,Link } from '@react-pdf/renderer';



const styles = StyleSheet.create({
    titleContainer: {
        marginTop: 12
    },
    reportTitle: {
        fontSize: 12,
        textAlign: 'center',
        textTransform: 'uppercase',
    },
    bold:{
     fontFamily:'Times-Bold',
     color: "#0B5F68",
     textAlign:'center',
     fontSize:25,
     textDecoration:'underline',   
     marginTop:"20px",
    },
    bold1:{
       marginTop:10, 
       fontFamily:'Times-Bold',
       fontStyle:'italic',
       color: "#0B5F68",
       fontSize:16,
       textDecoration:'underline', 
    },
    
      billTo: {
        marginTop: 10,
        fontFamily: 'Times-Bold',
        color: '#0B5F68',
    },
    blackText: {
        color: 'black',
    },
    goto: {
       marginTop:"10px",
    },
});

const InvoiceThankYouMsg = () => (
    <View style={styles.titleContainer}>
<Text style={styles.bold1} >Congratulations! :</Text>
<Text>Congratulations! Ap Ki Registration  Batch 02 Course Main Hogai Hai. Please Registration Ko Confirm Kernay K Lye Apni Fee Rs:3000/= Pay Karen</Text>


<Text style={styles.bold}>Payment Method</Text>
<Text style={styles.bold1} >Bank Details :</Text>
<Text style={styles.billTo}>
Bank Name: <Text style={styles.blackText}>MCB Islamic</Text>
        </Text>

<Text style={styles.billTo}>
Account Title: <Text style={styles.blackText}> Muhammad Rizwan</Text>
        </Text>

<Text style={styles.billTo}>
Account Number: <Text style={styles.blackText}>  1321004689390001</Text>
        </Text>




{/*

<Text>Account No: (1321004689390001) IBAN No: (PK34 MCIB 1321 0046 8939 0001 ) Account Title Muhammad Rizwan.</Text> */}



<Text style={styles.bold1} >Online Via Easy Paisa:</Text>

<Text style={styles.billTo}>
Account Title: <Text style={styles.blackText}> Muhammad Rizwan</Text>
        </Text>

<Text style={styles.billTo}>
Mobile Number: <Text style={styles.blackText}> 0343-4192648</Text>
        </Text>

        <Text style={styles.bold1} >Payment Verification Link
</Text>
        <Text><Link src={'https://registration-form-kids.vercel.app/payment'}>https://registration-form-kids.vercel.app/payment</Link></Text>;

{/* <Text style={styles.goto}>Go to any Mobile Communication shop & ask him to transfer fees i.e. Rs. 2000 (3 months’ fees) to this number 03434192648 via Easy Paisa, or if you have an account on Easy Paisa, you can transfer via it as well. Once the payment is done, please submit the screenshot above. For Further queries contact the Official number 03434192648</Text>     
         */}
 <Text style={styles.goto}>Payment Submit Kerny Ke Bad Screenshot Diye Gye Link Per Uplode Ker Or 20-May Se Apni Classes Main Shamil Hojain. Mazeed details ke liye rabta karen 
0343-4192648</Text>     
         

    
{/* <Text style={styles.bold1} >Follow Me
</Text>
        <Text><Link src={'https://www.facebook.com/sirrizwanbhatti'}>Facebook Page</Link></Text>;
        <Text><Link src={'https://www.facebook.com/rizwanbhatti15'}>Facebook Profile</Link></Text>;

         */}
        
        
        
        <Text style={styles.bold}>*** Thank You ***</Text>




    </View>
);

export default InvoiceThankYouMsg